export const TOKEN_EXPIRY_TIME = 1000 * 60 * 15;

export const specialPages = ["home"];
export const dummyIcon =
  "https://www.oundleschool.org.uk/wp-content/uploads/2019/11/20140902_Oundle_School_Buildings_069-2-2-1424x953.jpg";
